import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { pageInitSize } from "utils/HelperFunction";
import { getAllNewSo } from "../../redux/slices/logic/getAllNewSo.slice";
import { debounce } from "@mui/material";
export default function useInitSoDataList(param) {
    var initStatus = param.initStatus;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState([]), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState2[0], setPageModel = _useState2[1];
    var _useState3 = _sliced_to_array(useState(initStatus), 2), btnempstatus = _useState3[0], setBtnempstatus = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
    }), 2), soStatusCount = _useState4[0], setSoStatusCount = _useState4[1];
    var _useState5 = _sliced_to_array(useState(null), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    // Reducers
    var reducers = {
        getAllNewSo: useAppSelector(function(state) {
            return state.getAllNewSoReducer;
        })
    };
    var isMemoLoading = useMemo(function() {
        return reducers.getAllNewSo.isFetching;
    }, [
        reducers.getAllNewSo.isFetching
    ]);
    var getData = useCallback(function(param) {
        var page = param.page, limit = param.limit, searchText = param.searchText, mstNewStatusID = param.mstNewStatusID;
        var queryParams = _object_spread({
            page: page,
            limit: limit,
            searchText: searchText
        }, Array.isArray(mstNewStatusID) ? {
            mstNewStatusIDList: mstNewStatusID
        } : mstNewStatusID !== undefined && mstNewStatusID !== null ? {
            mstNewStatusID: mstNewStatusID
        } : {});
        dispatch(getAllNewSo({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        getData({
            page: 1,
            limit: pageModel.pageSize,
            searchText: "",
            mstNewStatusID: btnempstatus
        });
    }, []);
    useEffect(function() {
        if (reducers.getAllNewSo.data) {
            var result = reducers.getAllNewSo.data.data.data;
            var meta = reducers.getAllNewSo.data.data.meta;
            var soStatusCount = reducers.getAllNewSo.data.data.soStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            // console.log(result)
            setTab(result);
            setSoStatusCount(function(prev) {
                return _object_spread({}, prev, soStatusCount);
            });
        }
    }, [
        reducers.getAllNewSo.data
    ]);
    var debouncedSearch = useMemo(function() {
        return debounce(function(param) {
            var searchText = param.searchText, btnempstatus = param.btnempstatus;
            getData({
                page: 1,
                limit: pageModel.pageSize,
                searchText: searchText,
                mstNewStatusID: btnempstatus
            });
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch({
                searchText: filterText || "",
                btnempstatus: btnempstatus || ""
            });
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData({
            page: 1,
            limit: pageModel.pageSize,
            searchText: filterText || "",
            mstNewStatusID: btnempstatus
        });
    }, [
        btnempstatus
    ]);
    return {
        pageModel: pageModel,
        setPageModel: setPageModel,
        filterText: filterText,
        setFilterText: setFilterText,
        data: data,
        setData: setData,
        btnempstatus: btnempstatus,
        setBtnempstatus: setBtnempstatus,
        getData: getData,
        isMemoLoading: isMemoLoading,
        soStatusCount: soStatusCount
    };
}
